import { message } from 'ant-design-vue/es'; // import defaultSettings from '../defaultSettings';

import store from '@/store';
var lessNodesAppended;
var colorList = [{
  key: '薄暮',
  color: '#F5222D'
}, {
  key: '火山',
  color: '#FA541C'
}, {
  key: '日暮',
  color: '#FAAD14'
}, {
  key: '明青',
  color: '#13C2C2'
}, {
  key: '极光绿',
  color: '#52C41A'
}, {
  key: '拂晓蓝（默认）',
  color: '#1890FF'
}, {
  key: '极客蓝',
  color: '#2F54EB'
}, {
  key: '酱紫',
  color: '#722ED1'
}];

var updateTheme = function updateTheme(primaryColor) {
  // Don't compile less in production!

  /* if (process.env.NODE_ENV === 'production') {
    return;
  } */
  // Determine if the component is remounted
  if (!primaryColor) {
    return;
  } // window.localStorage.setItem("bgColor",primaryColor)


  var hideMessage = message.loading('正在编译主题！', 0);

  function buildIt() {
    if (!window.less) {
      return;
    }

    setTimeout(function () {
      window.less.modifyVars({
        '@primary-color': primaryColor
      }).then(function () {
        hideMessage();
        store.dispatch('ChangeColor', primaryColor);
      }).catch(function () {
        message.error('Failed to update theme');
        hideMessage();
      });
    }, 200);
  }

  if (!lessNodesAppended) {
    // insert less.js and color.less
    var lessStyleNode = document.createElement('link');
    var lessConfigNode = document.createElement('script');
    var lessScriptNode = document.createElement('script');
    lessStyleNode.setAttribute('rel', 'stylesheet/less');
    lessStyleNode.setAttribute('href', '/color.less');
    lessConfigNode.innerHTML = "\n      window.less = {\n        async: true,\n        env: 'production',\n        javascriptEnabled: true\n      };\n    ";
    lessScriptNode.src = 'https://gw.alipayobjects.com/os/lib/less.js/3.8.1/less.min.js';
    lessScriptNode.async = true;

    lessScriptNode.onload = function () {
      buildIt();
      lessScriptNode.onload = null;
    };

    document.body.appendChild(lessStyleNode);
    document.body.appendChild(lessConfigNode);
    document.body.appendChild(lessScriptNode);
    lessNodesAppended = true;
  } else {
    buildIt();
  }
};

var updateColorWeak = function updateColorWeak(colorWeak) {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  colorWeak ? document.body.classList.add('colorWeak') : document.body.classList.remove('colorWeak');
};

export { updateTheme, colorList, updateColorWeak };